import { createTheme } from '@mui/material/styles';
import '@mui/x-data-grid/themeAugmentation';
import { GridPanel } from './GridPanel';
import colors from './colors.module.scss';

export const trebleTheme = createTheme({
  typography: {
    fontFamily: ['"Inter"', 'Helvetica', 'Arial', 'sans-serif'].join(','),
  },
});

export const darkTheme = createTheme({
  ...trebleTheme,
  components: {
    MuiDataGrid: {
      defaultProps: {
        slots: { panel: GridPanel },
        slotProps: {
          baseTextField: { variant: 'standard' },
          baseSelect: { variant: 'standard' },
        },
      },
      styleOverrides: {
        menu: {
          '.MuiDataGrid-menuList': {
            minWidth: '160px',
          },
          '.MuiMenuItem-root': {
            minHeight: 'auto',
            gap: '8px',
          },
          '.MuiListItemIcon-root': {
            minWidth: 'auto',
            '.MuiSvgIcon-root': { fontSize: '16px' },
          },
          '.MuiListItemText-root': {
            margin: 0,
            '.MuiTypography-root': { fontSize: '11px', lineHeight: '12px' },
          },
        },
        panel: {
          '.MuiDataGrid-panelWrapper': {
            backgroundColor: colors.gray100,
          },
          '.MuiDataGrid-filterForm': {
            padding: '12px',
            gap: '12px',
          },
          '.MuiFormControl-root': {
            width: 'auto',
          },
          '.MuiDataGrid-filterFormValueInput': {
            flex: 1,
          },
          '.MuiInputLabel-root': {
            fontSize: '11px',
            transform: 'translate(0, -1.5px) scale(0.75)',
          },
          '.MuiInputBase-root': {
            fontSize: '12px',
          },
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        body2: {
          fontSize: '0.75rem',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          fontSize: '14px',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          fontSize: '14px',
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        outlined: {
          border: 'none',
          padding: '8px 12px',
          display: 'flex',
        },
      },
    },
    MuiNativeSelect: {
      styleOverrides: {
        select: {
          '> option': {
            color: '#dadada',
          },
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          width: '100%',
        },
      },
    },
    MuiListSubheader: {
      styleOverrides: {
        root: {
          backgroundColor: colors.gray100,
          color: colors.gray700,
          padding: '0 12px',
          lineHeight: 'inherit',
          fontSize: '11px',
          fontWeight: 'bold',
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          backgroundColor: colors.gray100,
          padding: '10px 12px',
          lineHeight: '12px',
          fontSize: '11px',
          '&.Mui-selected[aria-selected="false"]': {
            background: 'none',
          },
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          backgroundColor: colors.gray100,
          maxHeight: '450px',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          padding: 0,
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          minHeight: '28px',
        },
        indicator: {
          backgroundColor: '#DADADA',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            fontWeight: 700,
          },
        },
      },
    },
  },
  palette: {
    mode: 'dark',
    primary: {
      main: colors.trebleGreen,
    },
    secondary: {
      main: colors.trebleLightGreen,
    },
    text: {
      primary: colors.gray1000,
    },
    background: {
      default: colors.gray100,
      paper: colors.gray200,
    },
    error: {
      main: colors.trebleRed,
    },
    warning: {
      main: colors.trebleOrange,
    },
    info: {
      main: colors.gray800,
    },
    action: {
      disabled: '#00000000',
    },
  },
});
